module.exports = __webpack_public_path__ + "static/sth-659e750e065286d7f4f5acb2223ba7b2.png";